import React from "react";
import CardContentButtons from 'components/tile/CardContentButtons';
import FavoriteButton from 'components/FavoriteButton';
import WebComponent from "./WebComponent";
import LoginModalBtn from 'components/auth/buttons/LoginModalBtn';


class ContentActionButtons extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      trailmixModalOpen: false
    };

    this.addButtons()
  }

  componentDidMount() {
    document
      .getElementsByTagName('th-trailmix-add-modal')[0]
      .addEventListener("requestclose", (e) => this.closeTrailmixModal())
  }

  addButtons() {
    const { content, trailsV2TrailmixesEnabled } = this.props;

    this.buttons = [];
    this.buttons.push(this.favoriteButton());

    // Only show trailmix button if the content is not trail_v2 or the split feature is enabled for trails_v2
    // Also hide for employee trails
    const isEmployeeTrail = this.props?.content?.isEmployeeTrail;
    if ((content.contentType !== "trail_v2" || trailsV2TrailmixesEnabled) && !isEmployeeTrail) {
      this.buttons.push(this.addToTrailmixButton())
    }
  }

  favoriteButton() {
    const {
      user,
      renderAsButton,
      labels,
      content: { apiName, type, contentType }
    } = this.props;

    if (type === 'customstep' || type === 'trailmix') return null;
    const authenticated = !!user;

    const isFavorite = !!(this.props.user && this.props.user.favorited);
    const favKey = `${type}-${apiName}-${isFavorite}`;
    if (type !== 'preview_module') {
      return (
        <FavoriteButton
          favorited={isFavorite}
          authenticated={authenticated}
          apiName={apiName}
          contentType={contentType}
          type={type}
          key={favKey}
          renderAsButton={renderAsButton}
          labels={labels}
        />
      )
    }
  }

  trailmixModal() {
    const {
      content: {
        apiName,
        type,
        contentUid,
        path,
        color,
        image,
        subtitle,
        title,
        description,
        timeLeft,
        points,
      }
    } = this.props;

    let slug = null;
    if (this.props.user) {
      slug = this.props.user.slug
    }

    // Override type for agentblazer_trail to trail
    const modalType = type === 'agentblazer_trail' ? 'trail' : type;

    return (
        <WebComponent
          tagName="th-trailmix-add-modal"
          attrs={{
            config: {
              learning: {
                name: apiName,
                type: modalType.toUpperCase(),
              },
              ...(slug && {
                user: {
                  username: slug,
                },
              }),
            },
            open: this.state.trailmixModalOpen,
            summary: {
              id: contentUid,
              path: path,
              color: color,
              type: modalType.toUpperCase(),
              image: image,
              pretitle: subtitle,
              title: title,
              description: description,
              estimatedTime: timeLeft,
              points: points,
            },
          }}
        />
    )
  }
  
  closeTrailmixModal = () => {
    this.setState({
      trailmixModalOpen: false
    })
  }

  openTrailmixModal = () => {
    this.setState({
      trailmixModalOpen: true
    })
  }

  addToTrailmixButton() {
    if (!this.props.user) {
      return (
        <div style={{width: "100%"}}>
          <LoginModalBtn
            content={this.props.trailmixButtonLabels.addToTrailmix}
            className="slds-grid slds-button slds-button_neutral th-content-card__button"
          />
        </div>
      )
    }
    return (
      <div style={{width: "100%"}}>
        <button
          className="slds-grid slds-button slds-button_neutral th-content-card__button"
          onClick={this.openTrailmixModal}
          aria-label={""}
        >
        <span>
          {this.props.trailmixButtonLabels.addToTrailmix}
        </span>
      </button>
    </div>
    );
  }

  render() {
  const { className } = this.props;

  return (
    <div>
      <div className={`slds-grow tds-content__buttons ${className || ""}`} style={{fontSize: "1rem"}}>
        {this.buttons && (
          <CardContentButtons buttons={this.buttons} />
        )}
      </div>
      {this.trailmixModal()}
    </div>


  );
}
}

export default ContentActionButtons;
